import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { ShieldCheckIcon } from 'lucide-react';
export function FinalOffer() {
  return <section id="offer" className="py-24 bg-navy text-white relative overflow-hidden border-t-4 border-gold/60" data-id="element-45">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-46"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-47">
        <div className="max-w-4xl mx-auto text-center" data-id="element-48">
          <FadeIn data-id="element-49">
            <h2 className="text-4xl md:text-5xl font-bold font-serif text-white mb-8" data-id="element-50">
              Obtén <span className="text-gold" data-id="element-51">El Código de Habacuc</span> hoy
              mismo.
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-52">
            <p className="text-xl md:text-2xl text-parchment/80 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-53">
              No permitas que otro mes pase bajo la sombra de la escasez cuando
              la llave de tu provisión cuesta menos que un almuerzo.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-54">
            <div className="bg-navy-dark/60 border border-gold/30 rounded-2xl p-8 md:p-12 max-w-2xl mx-auto backdrop-blur-sm shadow-2xl" data-id="element-55">
              <div className="inline-block bg-red-900/40 text-red-200 border border-red-800/50 px-4 py-1.5 rounded-full text-sm font-bold tracking-wider uppercase mb-6" data-id="element-56">
                Precio Especial de Lanzamiento
              </div>

              <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-57">
                <span className="text-6xl md:text-7xl font-bold text-white tracking-tight" data-id="element-58">
                  $6.36
                </span>
                <span className="text-xl text-gold font-bold" data-id="element-59">USD</span>
              </div>

              <div className="flex justify-center mb-6" data-id="element-60">
                <ButtonCTA scrollToOffer={false} className="w-full md:w-auto text-xl py-5 px-10" data-id="element-61" />
              </div>

              <div className="flex items-center justify-center gap-2 text-parchment/60 text-sm" data-id="element-62">
                <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-63" />
                <span data-id="element-64">Acceso inmediato tras la compra. Pago 100% seguro.</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}